import { render, staticRenderFns } from "./VirtualAccount.vue?vue&type=template&id=74806f10&scoped=true"
import script from "./VirtualAccount.vue?vue&type=script&lang=js"
export * from "./VirtualAccount.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccount.vue?vue&type=style&index=0&id=74806f10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74806f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74806f10')) {
      api.createRecord('74806f10', component.options)
    } else {
      api.reload('74806f10', component.options)
    }
    module.hot.accept("./VirtualAccount.vue?vue&type=template&id=74806f10&scoped=true", function () {
      api.rerender('74806f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinancialManagementNew/components/VirtualAccount.vue"
export default component.exports